export default "__VITE_ASSET__OA2oigBT__"